import { /*CRUDBasicDetailComponent_Template, */CRUDBasicDetailComponent } from '../crud-basic-detail/crud-basic-detail.component';

import { Component, OnInit, Inject, forwardRef, Injector, ViewChild, Input } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder, AbstractControl, FormControlName } from '@angular/forms';
import { AppComponent } from '../app.component';
import { TranslateService } from '../_services/translate.service';
import { GenericValidator } from '../_helpers/generic-validator';
//import { AutoComplete } from 'primeng/primeng';

import { InventurService } from '../_services/inventur.service';
import { InventurDetailGuard } from './inventur-detail.guard';
import { FileUpload } from 'primeng/fileupload';
import { InventurFotosService } from '../_services/inventur-fotos.service';
import { IInventurFotos } from '../_interfaces/inventur-fotos';
import { DispositionskennzeichenService } from '../_services/dispositionskennzeichen.service';
import { IDispositionskennzeichen } from '../_interfaces/dispositionskennzeichen';
import { VerfuegbarkeitsstatusService } from '../_services/verfuegbarkeitsstatus.service';
import { IVerfuegbarkeitsstatus } from '../_interfaces/verfuegbarkeitsstatus';
import { HerstellerService } from '../_services/hersteller.service';
import { IHersteller } from '../_interfaces/hersteller';
import { IInventur } from '../_interfaces/inventur';

//import { InventurDetailComponent_Template } from './#fileName#-detail.component.include_template';

@Component({
  selector: 'app-inventur-detail',
  //template: `${CRUDBasicDetailComponent_Template || ''}${InventurDetailComponent_Template}`,
  templateUrl: './inventur-detail.component.html',
  styleUrls: ['../crud-basic-detail/crud-basic-detail.component.css', './inventur-detail.component.scss'],
  host: { '(window:keydown)': 'hotkeys($event)' }
})
export class InventurDetailComponent extends CRUDBasicDetailComponent implements OnInit {
  // CHILD-spezifisch: Konstanten - START
  CRUDItemKurzform: string = "Inventur";
  CRUDPageTitleNeu: string = this.translate.instant("Neue Inventur", true);
  CRUDPageTitleBearbeiten: string = this.translate.instant("Inventur bearbeiten", true);
  CRUDItemBezeichnungSingularCapitalized: string = "Inventur";
  CRUDItemBezeichnungPluralCapitalized: string = "Inventuren";
  CRUDItemBezeichnungSingular: string = "inventur";
  CRUDItemBezeichnungPlural: string = "inventuren";
  CRUDItemRouteSingular: string = "inventur";
  CRUDItemRoutePlural: string = "inventuren";
  CRUDItemHelpTopic: string = "Inventur";
  // CHILD-spezifisch: Konstanten - Ende

  // CHILD-spezifisch: zusätzliche Widgets (ausser Standard Inputs, Autocomplete) - START
  // Bilder
    // WICHTIG:
    // this.inventurFotosFileUpload.files + this.inventurFotosGalleryImages IMMER GLEICHZIEHEN, this.CRUDItem.inventurFotos nur bei getValuesFromForm akualisieren!
    @ViewChild('inventurFotosFileUpload') public inventurFotosFileUpload: FileUpload;
    //@ViewChild('inventurFotosGalleria') public inventurFotosGalleria: Galleria;
    inventurFotosFileUpload_files : File[] = [];
    //inventurFotosGalleryImages: Image[] = null;
    //inventurFotosDisplayGalleryOrUpload: string = "U";
    inventurFotosTitlePicGuid: string = "00000000"; // guid des Titelbildes
    //inventurFotosAlreadySwitchedToGallery: boolean = false; // schon einmal autom. auf Gallery geswitched (das machen wir nur 1mal, danach soll der User manuell switchen)
    inventurFotoAktuellUploadingFile: any = null;
    inventurFotoIsUploading = false;
    inventurFotoAccordionSelected = true;
  
    dispositionskennzeichen_bezeichnungen = [null, null, null, null, null, null];
  
    public initCompleted: boolean = false; // alles, was die Anwendung zum laufen braucht ist initialisiert, also: ...
    private initToBeDone: string = "+VERFUEGBARKEIT++HERSTELLER+"; // ... all das! wird von reportCompleted() ausgetragen
  
    verfuegbarkeitOptions = [
      //{ value: 'XXX', summary: 'xxx' },
    ];
    verfuegbarkeitOptionSelected = null;
  
    herstellerOptions = [
      //{ value: 'XXX', summary: 'xxx' },
    ];
    herstellertOptionSelected = null;
    umbauHerstellertOptionSelected = null;
  
    zustandOptions = [
      { value: null, summary: null },
      { value: 'Schrott', summary: 'Schrott' },
      { value: 'Kein Schrott', summary: 'Kein Schrott' },
    ];
    zustandOptionSelected = null;

    // CHILD-spezifisch: zusätzliche Widgets (ausser Standard Inputs, Autocomplete) - ENDE

  constructor(
    @Inject( forwardRef(() => AppComponent)) public _app: AppComponent,
    private _injector: Injector,
    private _translate: TranslateService,
    private _crudItemService: InventurService,
    private _guard: InventurDetailGuard,
    private inventurFotosService: InventurFotosService,
    private dispositionskennzeichenService: DispositionskennzeichenService,
    private verfuegbarkeitsstatusService: VerfuegbarkeitsstatusService,
    private herstellerService: HerstellerService,

    // CHILD-spezifisch: zusätzliche Services - START
    // CHILD-spezifisch: zusätzliche Services - ENDE
  ) {
    super(_app, _injector);

    this.crudItemService = _crudItemService;
    this.guard = _guard;

    // CHILD-spezifisch die Validator Messages bestücken - START
    this.validationMessages =
    {
      behaelterNummer: {
        required: this._translate.instant('Behälter-Nummer', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Behälter-Nummer', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      hersteller: {
        required: this._translate.instant('Hersteller', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Hersteller', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      baujahr: {
        required: this._translate.instant('Baujahr', true) + ': ' + this._translate.instant('ist erforderlich', true),
      },

      lagerungsart: {
        required: this._translate.instant('Lagerungsart', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Lagerungsart', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      behaeltervolumen: { // Liter
        required: this._translate.instant('Behältervolumen', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Behältervolumen', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      behaeltergroesse: {
        required: this._translate.instant('Behältergrösse', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Behältergrösse', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      tankfarbe: {
        required: this._translate.instant('Tankfarbe', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Tankfarbe', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      zustand: {
        required: this._translate.instant('Zustand', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Zustand', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      verfuegbarkeitsstatus: {
        required: this._translate.instant('Verfügbarkeitsstatus', true) + ': ' + this._translate.instant('ist erforderlich', true),
        maxlength: this._translate.instant('Verfügbarkeitsstatus', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      bemerkung: {
        maxlength: this._translate.instant('Bemerkung', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      umbauNummer: {
        maxlength: this._translate.instant('Behälter-Nummer Umbau', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      umbauHersteller: {
        maxlength: this._translate.instant('Hersteller Umbau', true) + ' ' + this._translate.instant('darf 255 Zeichen nicht überschreiten', true)
      },

      //umbauBaujahr: {
      //},
      };
    // CHILD-spezifisch die Validator Messages bestücken - ENDE
    
    this.genericValidator = new GenericValidator(this.validationMessages);

    this.buildForm();
  }

  buildForm() {
    // CHILD-spezifisch die Form aufbauen - START
    this.CRUDForm = this.fb.group({
      behaelterNummer: ['', [Validators.required, Validators.maxLength(255)]],
      hersteller: ['', [Validators.required, Validators.maxLength(255)]],
      baujahr: [null, [Validators.required]],
      lagerungsart: ['', [Validators.required, Validators.maxLength(255)]],
      behaeltervolumen: ['', [Validators.required, Validators.maxLength(255)]], // Liter
      behaeltergroesse: ['', [Validators.required, Validators.maxLength(255)]],
      tankfarbe: ['', [Validators.required, Validators.maxLength(255)]],
      zustand: ['', [Validators.required, Validators.maxLength(255)]],
      verfuegbarkeitsstatus: ['', [Validators.required, Validators.maxLength(255)]],
      inventurdatum: [null],
      rueckgemeldet: [null],
      bemerkung: ['', [Validators.maxLength(1000)]],
      dienstleisterId: [0],
      behaelterId: [0],
      interneBehaelterNummer: [''],
      anlagenart: [''],
      tUEVDatum: [null],
      letzteBewegung: [null],
      faelligkeit: [null],
      letzteInnerePruefung: [null],
      letzteAeusserePruefung: [null],
      umbauNummer: ['', [Validators.maxLength(255)]],
      umbauBaujahr: [null],
      umbauHersteller: ['', [Validators.maxLength(255)]],
      vorhanden: [false],
      nrVersorgungsunternehmen: [''],
      dispokennzeichen_1: [false],
      dispokennzeichen_2: [false],
      dispokennzeichen_3: [false],
      dispokennzeichen_4: [false],
      dispokennzeichen_5: [false],
      dispokennzeichen_6: [false],
    });
    // CHILD-spezifisch die Form aufbauen - ENDE
  }

  ngOnInit() {
    this.blockedDocument = true;

    // CHILD-spezifische Zusätze, z.B. Nachladen anderer Entities - START
    // CHILD-spezifische Zusätze, z.B. Nachladen anderer Entities - ENDE

    super.ngOnInit();
  }

  getValuesFromForm() {
    let a = super.getValuesFromForm(); // Standard! do not change!

    // CHILD-spezifische assigns, z.B. spracheId aus strache.Id bestücken - START
    // CHILD-spezifische assigns, z.B. spracheId aus strache.Id bestücken - ENDE

    //console.log("InventurDetailComponent.getValuesFromForm() a:", a);
    return a;
  }

  sendValuesToForm() {
    // CHILD-spezifisch die Form patchen - START
    this.CRUDForm.patchValue({
      inventurdatum: this.CRUDItem.inventurdatum,
      rueckgemeldet: this.CRUDItem.rueckgemeldet,
      zustand: this.CRUDItem.zustand,
      bemerkung: this.CRUDItem.bemerkung,
      dienstleisterId: this.CRUDItem.dienstleisterId,
      behaelterId: this.CRUDItem.behaelterId,
      interneBehaelterNummer: this.CRUDItem.interneBehaelterNummer,
      behaelterNummer: this.CRUDItem.behaelterNummer,
      verfuegbarkeitsstatus: this.CRUDItem.verfuegbarkeitsstatus,
      behaeltervolumen: this.CRUDItem.behaeltervolumen, // Liter
      hersteller: this.CRUDItem.hersteller,
      baujahr: this.CRUDItem.baujahr != null ? new Date(this.CRUDItem.baujahr) : null,
      tankfarbe: this.CRUDItem.tankfarbe,
      lagerungsart: this.CRUDItem.lagerungsart,
      anlagenart: this.CRUDItem.anlagenart,
      tUEVDatum: this.CRUDItem.tUEVDatum,
      letzteBewegung: this.CRUDItem.letzteBewegung != null ? new Date(this.CRUDItem.letzteBewegung) : null, 
      behaeltergroesse: this.CRUDItem.behaeltergroesse, //
      faelligkeit: this.CRUDItem.faelligkeit != null ? new Date(this.CRUDItem.faelligkeit) : null, //
      letzteInnerePruefung: this.CRUDItem.letzteInnerePruefung != null ? new Date(this.CRUDItem.letzteInnerePruefung) : null, //
      letzteAeusserePruefung: this.CRUDItem.letzteAeusserePruefung != null ? new Date(this.CRUDItem.letzteAeusserePruefung) : null, //
      umbauNummer: this.CRUDItem.umbauNummer, //
      umbauBaujahr: this.CRUDItem.umbauBaujahr != null ? new Date(this.CRUDItem.umbauBaujahr) : null, //
      umbauHersteller: this.CRUDItem.umbauHersteller, //
      vorhanden: this.CRUDItem.vorhanden, //
      nrVersorgungsunternehmen: this.CRUDItem.nrVersorgungsunternehmen, //
      dispokennzeichen_1: this.CRUDItem.dispokennzeichen_1, // 
      dispokennzeichen_2: this.CRUDItem.dispokennzeichen_2, //
      dispokennzeichen_3: this.CRUDItem.dispokennzeichen_3, //
      dispokennzeichen_4: this.CRUDItem.dispokennzeichen_4, //
      dispokennzeichen_5: this.CRUDItem.dispokennzeichen_5, //
      dispokennzeichen_6: this.CRUDItem.dispokennzeichen_6 //
    });

    const verfuegbarkeit = this.verfuegbarkeitOptions.find(f => f.value == this.CRUDItem.verfuegbarkeitsstatus);
    this.verfuegbarkeitOptionSelected = verfuegbarkeit;
    const hersteller = this.herstellerOptions.find(f => f.value == this.CRUDItem.hersteller);
    this.herstellertOptionSelected = hersteller;
    const umbauHersteller = this.herstellerOptions.find(f => f.value == this.CRUDItem.umbauHersteller);
    this.umbauHerstellertOptionSelected = umbauHersteller;
    const zustand = this.zustandOptions.find(f => f.value == this.CRUDItem.zustand);
    this.zustandOptionSelected = zustand;

    // CHILD-spezifisch die Form patchen - ENDE
    //console.log("InventurDetailComponent.sendValuesToForm() CRUDForm:", this.CRUDForm);
    super.sendValuesToForm(); // haben nicht alle DetailComponents - erst ab Ticket 9412 17.07.2019
  }

  onCRUDItemRetrieved(CRUDItem: /*IAnrede*/any): void {
    console.log("InventurDetail.onCRUDItemRetrieved()  CRUDItem:", CRUDItem);

    this.dispositionskennzeichenService.getDispositionskennzeichenForVersorgungsunternehmen(CRUDItem.nrVersorgungsunternehmen, 'B').subscribe(response => {
      console.log("InventurDetail.onCRUDItemRetrieved() getDispositionskennzeichenForVersorgungsunternehmen (dispo) response:", response);
      this.dispositionskennzeichen_bezeichnungen = [null, null, null, null, null, null];
      (response.dispositionskennzeichen as IDispositionskennzeichen[]).forEach(kennzeichen => {
        console.log("InventurDetail.onCRUDItemRetrieved() getDispositionskennzeichenForVersorgungsunternehmen dispokennzeichen:", kennzeichen);
        this.dispositionskennzeichen_bezeichnungen[kennzeichen.kennzeichenNr - 1] = kennzeichen.bezeichnung;
      });
    }, error => {
      console.error("InventurDetail.onCRUDItemRetrieved() getDispositionskennzeichenForVersorgungsunternehmen error:", error);
      ///*return*/ this.handleError(error); 
    });

    this.verfuegbarkeitsstatusService.getVerfuegbarkeitsstatusForVersorgungsunternehmen(CRUDItem.nrVersorgungsunternehmen).subscribe(response => {
      console.log("InventurDetail.onCRUDItemRetrieved() getVerfuegbarkeitsstatusForVersorgungsunternehmen (verfuegbarkeit) response:", response);
      (response.verfuegbarkeitsstatus as IVerfuegbarkeitsstatus[]).forEach(verfuegbarkeitsstatus => {
        console.log("InventurDetail.onCRUDItemRetrieved() getVerfuegbarkeitsstatusForVersorgungsunternehmen verfuegbarkeitsstatus:", verfuegbarkeitsstatus);
        this.verfuegbarkeitOptions.push({ value: verfuegbarkeitsstatus.status, summary: verfuegbarkeitsstatus.bezeichnung });
      });

      this.reportCompleted("+VERFUEGBARKEIT+", CRUDItem); // erst wenn alles verfügbar geht's weiter mit onCRUDItemRetrieved() (weil in sendValuesToForm die verfügbarkeitOptions geladen sein müssen!)
    }, error => {
      console.error("InventurDetail.onCRUDItemRetrieved() getVerfuegbarkeitsstatusForVersorgungsunternehmen error:", error);
      ///*return*/ this.handleError(error); 
    });

    this.herstellerService.getHerstellerCollection(1, 0, '').subscribe(response => {
      console.log("InventurDetail.onCRUDItemRetrieved() getHerstellerCollection (verfuegbarkeit) response:", response);
      (response.hersteller as IHersteller[]).forEach(hersteller => {
        console.log("InventurDetail.onCRUDItemRetrieved() getHerstellerCollection hersteller:", hersteller);
        this.herstellerOptions.push({ value: hersteller.hersteller, summary: hersteller.bezeichnung });
      });

      this.reportCompleted("+HERSTELLER+", CRUDItem); // erst wenn alles verfügbar geht's weiter mit onCRUDItemRetrieved() (weil in sendValuesToForm die verfügbarkeitOptions geladen sein müssen!)
    }, error => {
      console.error("InventurDetail.onCRUDItemRetrieved() getHerstellerCollection error:", error);
      ///*return*/ this.handleError(error); 
    });
  }  

  onNGFileInputSelect(event, bereich) {
    console.log("InventurDetail.onNGFileInputSelect().event/bereich:", event, bereich);

    // in der App: Event senden für nativen upload -> Das passiert so gar nicht! siehe stattdessen uploadFromX()
    /*if(this.app.inAppMode == true) {
      // nur bei App: Bild wird "nativ"/MAUI aufgenommen - und per JS an uploadFromCameraNative() gesandt
      if(window.navigator.userAgent.indexOf('DLPApp_Android') >= 0  || window.navigator.userAgent.indexOf('DLPApp_iOS') >= 0) {
        console.log("Checkliste.onNGFileInputSelect() Android / iOS = upload 'native'");

        setTimeout(() => {
          let eventData = {
              eventType: "fotoPicker",
              data: JSON.stringify(
              {
                bereich: bereich,
                acceptImage: true,
                acceptPDF: bereich == 'A' ? true : false
              })
          };
          this.app.sendMessageToDotNet(eventData);
        }, 10);		

        return;
      }
    }*/

    //this.app.writeAppDebugLog("InventurDetail.onNGFileInputSelect().event:"+ event, 0); // US 33968: Test Android Kamera
    //this.app.writeAppDebugLog("InventurDetail.onNGFileInputSelect().bereich:"+ bereich, 0); // US 33968: Test Android Kamera 
    let fileUpload:FileUpload = null;
    let fileUpload_files:File[] = null;
    fileUpload = this.inventurFotosFileUpload;
    fileUpload_files = this.inventurFotosFileUpload_files;

    //let fileToUpload : File = event.files[0];
    for (let i: number = 0; i < event.files.length; i++) {
      let fileToUpload: File = event.files[i];
      console.log("InventurDetail.onNGFileInputSelect() fileToUpload:", fileToUpload);
      //this.app.writeAppDebugLog("InventurDetail.onNGFileInputSelect() fileToUpload:"+ fileToUpload, 0); // US 33968: Test Android Kamera 

      /*const formData = new FormData();
      formData.append('file', fileToUpload, fileToUpload.name);
      let httpClient = this.inventurFotosService.getHTTPClient();
      let apiBaseURL = this.inventurFotosService.getApiBaseUrl();
      httpClient.post(apiBaseURL + 'inventurFotos', formData, {reportProgress: true, observe: 'events'})
        .subscribe(event => {
          console.log("ArtikelDetail.uploadFile() event:", event);
          //if (event.type === HttpEventType.UploadProgress) {
            //let progress = Math.round(100 * event.loaded / event.total);
            //console.log("ArtikelDetail.uploadFile() progress:", progress);
          //}
          //else if (event.type === HttpEventType.Response) {
          //  console.log("ArtikelDetail.uploadFile() success!");
          //}
        });
      */

      /*
      // nicht nur das file uploaden, sondern auch die Entity "inventurFoto"
      let inventurFotoForCreate = this.inventurFotosService.initializeinventurFoto();
      let dateiendung = fileToUpload.name.substr(fileToUpload.name.lastIndexOf('.') + 1);
      let dateiname = fileToUpload.name.substr(0, fileToUpload.name.length - (dateiendung.length + 1));
      inventurFotoForCreate.dateiname = dateiname;
      inventurFotoForCreate.dateiendung = dateiendung;
      inventurFotoForCreate.bezeichnung = fileToUpload.name;
      inventurFotoForCreate.sortierung = 99;
      */

      // in die fileUpload-Liste eintragen - in die interne von primeNg (._files) ist es schon - aber nicht im parameter inventurFotosFileUpload_files - also:
      // nur noch das eingetragene suchen - und als "noch nicht upgeloaded" markieren - UND IN den parameter inventurFotosFileUpload_files rüberkopieren
      // ACHTUNG HIER AUSNAHME ZU
      // this.inventurFotosFileUpload.files + this.inventurFotosGalleryImages IMMER GLEICHZIEHEN, this.CRUDItem.inventurFotos nur bei getValuesFromForm akualisieren!
      // GRUND: inventurFotosGalleryImages wird beim onSuccess aktualisiert
      /*
      let inventurFotosFilesOhneKennzeichnungAlreadyUploaded = this.inventurFotosFileUpload_files.filter(f => f['_alreadyUploaded'] == undefined);
      let inventurFotosFilesOhneKennzeichnungAlreadyUploadedMitDemNamen = inventurFotosFilesOhneKennzeichnungAlreadyUploaded.filter(f => f.name == fileToUpload.name);
      inventurFotosFilesOhneKennzeichnungAlreadyUploadedMitDemNamen.forEach(file => {
        file['_alreadyUploaded'] = false;
        file['_percentUploaded'] = 0;
        file['_guid'] = null;
      });
      */
      let inventurFotosFilesOhneKennzeichnungAlreadyUploaded = fileUpload._files.filter(f => f['_alreadyUploaded'] == undefined);
      let inventurFotosFilesOhneKennzeichnungAlreadyUploadedMitDemNamen = inventurFotosFilesOhneKennzeichnungAlreadyUploaded.filter(f => f.name == fileToUpload.name);
      inventurFotosFilesOhneKennzeichnungAlreadyUploadedMitDemNamen.forEach(file => {
        file['_alreadyUploaded'] = false;
        file['_percentUploaded'] = 0;
        file['_guid'] = null;
        file['_bereich'] = bereich;

        fileUpload_files.push(file);
      });

      //this.inventurFotosService.uploadinventurFoto(fileToUpload, inventurFotoForCreate, this, this.uploadProgress, this.uploadSuccess);
    }
    console.log("InventurDetail.onNGFileInputSelect() fileUpload.files:", fileUpload.files);
    //this.app.writeAppDebugLog("InventurDetail.onNGFileInputSelect() fileUpload.files:"+ fileUpload.files, 0); // US 33968: Test Android Kamera 

    setTimeout(() => {
      this.uploadNextinventurFoto();
    }, 200);

    //this.CRUDItem.positionsdaten['_touched'] == true;
    this.posMarkAsTouchedAndReCalc();
  }
  uploadNextinventurFoto() {
    console.log("InventurDetail.uploadNextinventurFoto()");
    if(this.inventurFotoIsUploading == true) {
      console.log("InventurDetail.uploadNextinventurFoto() 1 upload is running already - wait/retry!");
      setTimeout(() => {
        this.uploadNextinventurFoto();
      }, 500);
    }
    else {
      let fileUpload: FileUpload = this.inventurFotosFileUpload;
      let index = fileUpload.files.findIndex(i => i['_alreadyUploaded'] == false); // zuerst prüfen, ob es noch was hochzuladen gibt
      if (index >= 0) {
        this.inventurFotoIsUploading = true;
        let fileToUpload = fileUpload.files[index];
        this._uploadNextinventurFotoFor1FileUpload(fileUpload, fileToUpload);
      }
      else {
        console.log("InventurDetail.uploadNextinventurFoto() keine weiteren Uploads warten -> Ende!!");
      }
    }
  }
  _uploadNextinventurFotoFor1FileUpload(fileUpload: FileUpload, fileToUpload: File) {
    console.log("InventurDetail._uploadNextinventurFotoFor1FileUpload() fileUpload.files/fileToUpload:", fileUpload.files, fileToUpload);
      this.inventurFotoAktuellUploadingFile = fileToUpload; // merken für die progress-Rückmeldung
      console.log("InventurDetail._uploadNextinventurFotoFor1FileUpload() next fileToUpload:", fileToUpload);

      // nicht nur das file uploaden, sondern auch die Entity "inventurFoto"
      let inventurFotoForCreate = this.inventurFotosService.initializeInventurFotos();
      delete inventurFotoForCreate['bild']; // sonst kommen die Parameter beim Controller nicht an!
      let dateiendung = fileToUpload.name.substr(fileToUpload.name.lastIndexOf('.') + 1);
      let dateiname = fileToUpload.name.substr(0, fileToUpload.name.length - (dateiendung.length + 1));
      //inventurFotoForCreate.dateiname = dateiname;
      inventurFotoForCreate.dateiendung = dateiendung;
      //inventurFotoForCreate.bezeichnung = fileToUpload.name;
      //inventurFotoForCreate.sortierung = 99;
      inventurFotoForCreate.bemerkung = dateiname;

      //try {
        this.inventurFotosService.uploadInventurFotoToTemp(fileToUpload, inventurFotoForCreate, this, this.uploadProgress, this.uploadSuccess, this.uploadError);
      //}
      //catch(e) {
      //  console.error("InventurDetail.uploadNextinventurFoto() error:", e);
      //  this.handleError(e);
      //}
  }

  uploadError(thisInstance: InventurDetailComponent, error: any) {
    console.log("InventurDetail.uploadError() error:", error);
    thisInstance.handleError(error);
    //thisInstance.messageWrapperService.postTimedMessage({severity: 'info', summary: 'Upload: '+progress, detail: ''}); 
  }
  uploadProgress(thisInstance: InventurDetailComponent, progress: number) {
    console.log("InventurDetail.uploadProgress() progress:", progress);
    //thisInstance.messageWrapperService.postTimedMessage({severity: 'info', summary: 'Upload: '+progress, detail: ''}); 

    if (thisInstance.inventurFotoAktuellUploadingFile != null) {
      thisInstance.inventurFotoAktuellUploadingFile['_percentUploaded'] = progress;
    }
  }
  uploadSuccess(thisInstance: InventurDetailComponent, eventbody: any) {
    console.log("InventurDetail.uploadSuccess()");
    let originalFileName: string = eventbody.originalFileName;
    let guid: string = eventbody.guid;
    //let behoben = eventbody.behoben;
    let bereich = eventbody.bereich;
    console.log("InventurDetail.uploadSuccess() originalFileName:", originalFileName);
    console.log("InventurDetail.uploadSuccess() guid:", guid);
    thisInstance.messageWrapperService.postTimedMessage({ severity: 'info', summary: 'Datei ' + originalFileName + ': Upload erfolgreich!'/*+guid*/, detail: '' });

    let dateiendung = originalFileName.substr(originalFileName.lastIndexOf('.') + 1);
    let dateiname = originalFileName.substr(0, originalFileName.length - (dateiendung.length + 1));
    // this.inventurFotosFileUpload.files + this.inventurFotosGalleryImages IMMER GLEICHZIEHEN, this.CRUDItem.inventurFotos nur bei getValuesFromForm akualisieren!
    let newinventurFoto : IInventurFotos = thisInstance.inventurFotosService.initializeInventurFotos();
    newinventurFoto.inventur = null;
    newinventurFoto.inventurId = thisInstance.CRUDItem.id;
    //newinventurFoto.dateiname = dateiname;
    newinventurFoto.dateiendung = dateiendung;
    //newinventurFoto.bezeichnung = originalFileName;
    newinventurFoto.bemerkung = originalFileName;
    newinventurFoto.guid = guid;
    //newinventurFoto.sortierung = 99;
    newinventurFoto.id = 0;
    thisInstance.CRUDItem.inventurFotos.push(newinventurFoto);
    let fileUpload:FileUpload = null;
    let fileUpload_files:File[] = null;

    fileUpload = thisInstance.inventurFotosFileUpload;
    fileUpload_files = thisInstance.inventurFotosFileUpload_files;

    // das File als uploaded markieren
    let inventurFotosFilesMitDemDateinamen = fileUpload.files.filter(f => f.name == originalFileName);
    inventurFotosFilesMitDemDateinamen.forEach(file => {
      file['_alreadyUploaded'] = true;
      file['_percentUploaded'] = 100;
      file['_guid'] = guid;
    });

    console.log("InventurDetail.uploadSuccess() fileUpload.files:", fileUpload.files);

    // in gallery eintragen
    //let newImage: Image = new Image();
    //newImage.title = originalFileName;
    //newImage.thumbnailImageSrc = thisInstance.inventurFotosService.getThumbDownloadUrl(guid, dateiendung);
    //newImage.previewImageSrc = thisInstance.inventurFotosService.getDownloadUrl(guid, dateiendung);
    //thisInstance.inventurFotosGalleryImages.push(newImage);

    // war das das 1. Bild ? dann einmalig auf Gallery switchen (nur beim 1. Mal, danach soll User manuell switchen)
    /*if(thisInstance.inventurFotosAlreadySwitchedToGallery == false && thisInstance.inventurFotosGalleryImages.length == 1) {
      thisInstance.inventurFotosDisplayGalleryOrUpload = 'G';
    }
    thisInstance.inventurFotosAlreadySwitchedToGallery = true;*/

    // 1. Bild ? Dann als Titelbild markieren
    //if (thisInstance.inventurFotosGalleryImages.length == 1) {
    //  console.log("InventurDetail.uploadSuccess() setting inventurFotosTitlePicGuid:", guid);
    //  thisInstance.inventurFotosTitlePicGuid = guid;
    //  thisInstance.inventurFotosUseAsEditorBackground();
    //}

    thisInstance.inventurFotoAktuellUploadingFile = null; // merken für die progress-Rückmeldung

    // jetzt (nachdem 1 File fertig ist) -> das nächste uploaden.
    setTimeout(() => {
      thisInstance.inventurFotoIsUploading = false;
      thisInstance.uploadNextinventurFoto();
    }, 200);
  }

  onNGFileInputRemove($event) {
    console.log("InventurDetailComponent.onNGFileInputRemove()   NOT IN USE!");
  }

  posFileUploadUpdate(skipPhotoUpdate?: boolean) { // skipPhotoUpdate: wird genutzt beim Start, wo alle Pos geprüft werden (wäre im Browser nicht relevant, aber würde app-performance beeinträchtigen)
    //console.log("InventurDetailComponent.posFileUploadUpdate() posSelected/CRUDItem.positionsdaten[posSelected].inventurFotos:", this.posSelected, this.CRUDItem.positionsdaten[this.posSelected].inventurFotos);
    this.inventurFotosFileUpload_files = [];
    this.CRUDItem.inventurFotos.forEach(inventurFoto => {
      let newFile = new File([], inventurFoto.dateiname + "." + inventurFoto.dateiendung, {
        type: "image/" + (inventurFoto.dateiendung),
      });
      //newFile['objectURL'] = this.inventurFotosService.getThumbDownloadUrl(inventurFoto.guid, inventurFoto.dateiendung);
      //this.inventurFotosService.setThumbDownloadUrl(inventurFoto.guid, inventurFoto.dateiendung, newFile, 'objectURL');
      //console.log("InventurDetailComponent.posFileUploadUpdate() newFile['objectURL']:", newFile['objectURL']);

      //warum auch immer: das aktuelle primeNG macht auf "objectURL='http://localhost..." -> "blob:http://localhost" -> daher nochmal separat sepeichern:
      //Update: auf 'objectURL' kann man wohl verzichten, nur '_objectURL' reicht!
      //newFile['_objectURL'] = this.inventurFotosService.getThumbDownloadUrl(inventurFoto.guid, inventurFoto.dateiendung);
      if(skipPhotoUpdate != true) this.inventurFotosService.setThumbDownloadUrl(inventurFoto.guid, inventurFoto.dateiendung, newFile, '_objectURL');

      //let fileObj = (Object)newFile;
      //fileObj['name'] = inventurFoto.dateiname + "." + inventurFoto.dateiendung;
      newFile['_alreadyUploaded'] = true;
      newFile['_percentUploaded'] = 100;
      newFile['_guid'] = inventurFoto.guid;
      newFile['_inventurFoto'] = inventurFoto; // gleich die entity mit ranhängen, erleichtert das Aktualisieren des CRUDItems bei Save
      //newFile['_bereich'] = inventurFoto.behoben ? "B" : "M";
      newFile['_bereich'] = inventurFoto.bereich;
      console.log("InventurDetailComponent.posFileUploadUpdate() adding file to inventurFotosFileUpload.files:", newFile);
      this.inventurFotosFileUpload_files.push(newFile);  
    });
  }

  inventurBilderDeleteFile(file, bereich) {
    console.log("InventurDetailComponent.positionenBilderDeleteFile() file:", file);
    //console.log("InventurDetailComponent.positionenBilderDeleteFile() this:", this);
    let fileUpload:FileUpload = null;
    let fileUpload_files:File[] = null;
    fileUpload = this.inventurFotosFileUpload;
    fileUpload_files = this.inventurFotosFileUpload_files;

    let index = fileUpload_files.findIndex(f => f == file);
    let indexCrudItem = this.CRUDItem.inventurFotos.findIndex(f => f.guid == file._guid);
    if (index >= 0 && indexCrudItem >=0 ) {
      console.log("InventurDetailComponent.positionenBilderDeleteFile() deleting file:", file);

      // zuvor: ist das zu löschende Bild das Titelbild ? Dann autom. das 1. verbleibende als Titelbild wählen
      //let titelbidlGeloescht: boolean = this.inventurFotosFileUpload_files[index]['_guid'] == this.artikelBilderTitlePicGuid;

      //delete this.artikelbilderFileUpload.files[index];
      fileUpload_files.splice(index, 1); // im parameter löschen
      fileUpload._files.splice(index, 1); // im primeNg internen Parm auch löschen
      console.log("InventurDetailComponent.positionenBilderDeleteFile() inventurFotosFileUpload._files:", fileUpload._files);
      console.log("InventurDetailComponent.positionenBilderDeleteFile() inventurFotosFileUpload_files:", fileUpload_files);

      // auch direkt im cruditem löschen
      this.CRUDItem.inventurFotos.splice(indexCrudItem, 1);
      //console.log("InventurDetailComponent.positionenBilderDeleteFile() CRUDItem.positionsdaten[posSelected].inventurFotos:", this.CRUDItem.positionsdaten[this.posSelected].inventurFotos);
      //this.CRUDItem.positionsdaten['_touched'] == true;
      this.posMarkAsTouchedAndReCalc();
      
      // von Gallery löschen
      //this.artikelBilderGalleryImages.splice(index, 1);

      // NICHT aus CRUDItem löschen - weil:
      // this.artikelbilderFileUpload.files + this.artikelBilderGalleryImages IMMER GLEICHZIEHEN, this.CRUDItem.artikelbilder nur bei getValuesFromForm akualisieren!
      //this.CRUDItem.artikelbilder.splice(index, 1);

      // war das zu löschende Bild das Titelbild ? Dann autom. das 1. verbleibende als Titelbild wählen
      //if (titelbidlGeloescht == true) {
      //  if (this.artikelbilderFileUpload.files.length > 0) this.artikelBilderTitlePicGuid = this.artikelbilderFileUpload.files[0]['_guid'];
      //  else this.artikelBilderTitlePicGuid = "00000000";
      //}
    }
    else {
      console.log("InventurDetailComponent.positionenBilderDeleteFile() file to delete NOT FOUND!");
    }
  }

  posMarkAsTouchedAndReCalc() {
    this.CRUDForm.markAsDirty();
  }

  verfuegbarkeitOptionChanged(event: any) {
    console.log("InventurDetailComponent.verfuegbarkeitOptionChanged() event:", event);
    this.CRUDForm.patchValue({
      verfuegbarkeitsstatus: event.value.value
    });
  }

  herstellerOptionChanged(event: any) {
    console.log("InventurDetailComponent.herstellerOptionChanged() event:", event);
    this.CRUDForm.patchValue({
      hersteller: event.value.value
    });
  }

  umbauHerstellerOptionChanged(event: any) {
    console.log("InventurDetailComponent.umbauHerstellerOptionChanged() event:", event);
    this.CRUDForm.patchValue({
      umbauHersteller: event.value.value
    });
  }

  zustandOptionChanged(event: any) {
    console.log("InventurDetailComponent.zustandOptionChanged() event:", event);
    this.CRUDForm.patchValue({
      zustand: event.value.value
    });
  }

  reportCompleted(part: string, CRUDItem: IInventur) {
    console.log("InventurDetail.reportCompleted() part:", part);
    if (this.initToBeDone.includes(part)) {
      this.initToBeDone = this.initToBeDone.replace(part, "");
    }
    else {
      console.error("InventurDetail.reportCompleted() error: part war nicht zu erledigen: part:", part);
    }
    if (this.initToBeDone.length == 0) {
      this.initCompleted = true;
      console.log("InventurDetail.reportCompleted() initCompleted!");

      // erst jetzt weiter ! (weil in sendValuesToForm die verfügbarkeitOptions geladen sein müssen!)
      super.onCRUDItemRetrieved(CRUDItem);
      this.posFileUploadUpdate(false);
      this.blockedDocument = false;
    }
    else {
      console.log("InventurDetail.reportCompleted() left initToBeDone:", this.initToBeDone);
    }
  }

  rueckmeldenAndSave() {
    this.CRUDForm.patchValue({
      rueckgemeldet: new Date()
    });
    this.validateAndSaveCRUDItem(true);
  }

  getCRUDBezeichnung() { // overwrite
    return '';
  }

}
